import React from "react";
import { Translate } from "@phosphor-icons/react";
import { useLang } from "@/context/LanguageContext";

export const LanguageToggle = () => {
  const { lang, toggle } = useLang();
  return (
    <button
      onClick={toggle}
      data-testid="lang-toggle-btn"
      className="inline-flex items-center gap-2 border border-white/10 bg-[#121212] hover:bg-[#1C1C1C] px-3 py-2 text-xs uppercase tracking-[0.2em] text-zinc-300 transition-colors"
    >
      <Translate size={14} weight="bold" />
      <span>{lang === "ar" ? "EN" : "ع"}</span>
    </button>
  );
};
